import { render, staticRenderFns } from "./AdminAvailabilityMenu.vue?vue&type=template&id=6660022c"
import script from "./AdminAvailabilityMenu.vue?vue&type=script&lang=js"
export * from "./AdminAvailabilityMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports